<template>
<div>
  <p class="text-primary tc-wd-label mr-2">{{data}}</p> 
</div>
</template>

<script>

export default {
  components: {
    
  },
  props: {
    data: String
  }
}

</script>
